export const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const formatPrice = (price) => {
  return `$${new Intl.NumberFormat('en-US').format(price)}`;
};

const formats = ['MMMM dd', 'MM/dd/yyyy'];
// date string is presumed to come from API like "2020-01-01"
export const formatDate = (dateString, format) => {
  if (formats.indexOf(format) < 0) {
    throw new Error('Unsupported format!');
  }

  // eslint-disable-next-line default-case
  switch (format) {
    case formats[0]: {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const month = dateString.split('-')[1] - 1;
      const day = dateString.split('-')[2];
      return `${months[month]} ${day}`;
    }

    case formats[1]: {
      const year = dateString.split('-')[0];
      const month = dateString.split('-')[1];
      const day = dateString.split('-')[2];
      return `${month}/${day}/${year}`;
    }
  }
};

export const formatRawDate = (date) => {
  const month = date.getMonth() + 1;
  const formattedMonth = month > 9 ? month : `0${month}`;
  const day = date.getDate();
  const formattedDay = day > 9 ? day : `0${day}`;
  return `${date.getFullYear()}-${formattedMonth}-${formattedDay}`;
};

// Passing a string will get an issue in diff. timezone
export const getDateFromString = (dateString) => {
  const parts = dateString.split('-');
  return new Date(parts[0], parts[1] - 1, parts[2]);
};

export const getIsAdult = (age) => age > 18;

// Start and end dates are composed in an array objects
// Useful to avoid jumping camp date selection
// Eg. [{ start: "12-01-2020", end: "12-01-2020" }, { start: "19-01-2020", end: "26-01-2019" }]
export const getCampsIntervals = (camps) => {
  // Sort camps by start date
  let sorted = camps.sort(
    (a, b) => new Date(a.startDate) - new Date(b.startDate)
  );

  // initialize intervals with first camp
  const intervals = [{ start: sorted[0].startDate, end: sorted[0].endDate }];

  for (let i = 1; i < sorted.length; i++) {
    if (
      Number(sorted[i].startDate.replace(/-/g, '')) - 1 !==
      Number(sorted[i - 1].endDate.replace(/-/g, ''))
    ) {
      intervals.push({ start: sorted[i].startDate, end: sorted[i].endDate });
    } else {
      intervals[intervals.length - 1].end = sorted[i].endDate;
    }
  }

  return intervals;
};

// Promise resolutions will return an array of array,
// we first flatten it, then we group the same excursions with same name
// by pushing the dates together
// Eg. If query returns 2 "Tampa Ray" excursions, we must have
// a state variable containing 1 "Tampa Ray" with dates of the two
// Same logic will go into upsells

export const joinDates = (array) => {
  const newArray = [];

  for (let i = 0; i < array.length; i++) {
    let searchNameIndex = newArray.findIndex(
      (e) => e.display_name === array[i].display_name
    );
    if (searchNameIndex > -1) {
      newArray[searchNameIndex].dates.push(...array[i].dates);
    } else {
      newArray.push(array[i]);
    }
  }

  return newArray;
};

export const isEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const getAge = (birthdate) => {
  const today = new Date();
  const birthDate = new Date(birthdate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};
